import { isValidEmail } from "./validation";

export function isPendingBlockedJoin(row: {
  admittedAt?: Date | string | null;
}): boolean {
  return row.admittedAt == null;
}

export function normalizeBlockedJoinEmail(
  email: string | null | undefined,
): string | null {
  const trimmed = email?.trim().toLowerCase() ?? "";
  if (!trimmed || !isValidEmail(trimmed)) {
    return null;
  }
  return trimmed;
}

export function blockedJoinDisplayName(
  name: string | null | undefined,
  email: string,
): string {
  const trimmedName = name?.trim();
  if (trimmedName) {
    return trimmedName;
  }

  const localPart = email.split("@")[0]?.trim();
  return localPart || email;
}

export function formatBlockedJoinNameList(
  locale: string,
  names: readonly string[],
): string {
  const cleaned = names.map((name) => name.trim()).filter(Boolean);
  if (cleaned.length === 0) {
    return "";
  }

  return new Intl.ListFormat(locale, { type: "conjunction" }).format(cleaned);
}

export function isPartyMemberCapMessage(message: string): boolean {
  const trimmed = message.trim().toLowerCase();
  if (!trimmed) {
    return false;
  }

  return (
    trimmed.includes("free party is full") &&
    trimmed.includes("party pass")
  );
}

export const BLOCKED_JOIN_NUDGE_ERROR_CODES = [
  "invalidEmail",
  "partyNotFound",
  "alreadyUnlocked",
  "hostCannotNudge",
  "alreadyMember",
  "stillHasRoom",
  "signInRequired",
  "submitFailed",
] as const;

export type BlockedJoinNudgeErrorCode =
  (typeof BLOCKED_JOIN_NUDGE_ERROR_CODES)[number];

export function isBlockedJoinNudgeErrorCode(
  value: string,
): value is BlockedJoinNudgeErrorCode {
  return (BLOCKED_JOIN_NUDGE_ERROR_CODES as readonly string[]).includes(value);
}

export function resolveBlockedJoinNudgeErrorCode(
  error: unknown,
): BlockedJoinNudgeErrorCode {
  if (error instanceof Error && isBlockedJoinNudgeErrorCode(error.message)) {
    return error.message;
  }

  return "submitFailed";
}

export type BlockedJoinNudgeStatus = "idle" | "submitting" | "success" | "error";

export interface BlockedJoinNudgeSubmitResult {
  alreadyCaptured: boolean;
}

export type SubmitBlockedJoinNudge = (
  email: string,
) => Promise<BlockedJoinNudgeSubmitResult>;
